<template>
  <div id="page-selects" class="company-manage-page">
    <v-container grid-list-xl fluid class="company-manage-container">
      <breadcrumbs :routelinks="[
        { text: 'Company', href: '#/companies' },
        { text: 'Manage', href: '#/admin/admin-create', disabled: true }
      ]" />
      <div class="page-heading">
        <div>
          <div class="page-heading__eyebrow">{{ company._id ? "Manage School" : "Register School" }}</div>
          <h1 class="page-heading__title">{{ company.company_name || "Register School" }}</h1>
          <div class="page-heading__sub">
            Keep school profile, access, modules, and instance setup in one place.
          </div>
        </div>
        <v-chip
          v-if="company._id"
          small
          label
          class="page-heading__status"
          :color="company.company_id ? 'green lighten-5' : 'orange lighten-5'"
          :text-color="company.company_id ? 'green darken-2' : 'orange darken-3'"
        >
          <v-icon left small>{{ company.company_id ? "check_circle" : "schedule" }}</v-icon>
          {{ company.company_id ? "Active" : "Pending Setup" }}
        </v-chip>
      </div>
      <v-layout row wrap>
        <v-flex lg12 md12 xs12>
          <v-tabs
            v-if="company._id"
            fixed-tabs
            class="company-tabs"
            color="transparent"
            slider-color="primary"
          >
            <v-tab @click="showTab(0)">
              <v-icon small left>edit</v-icon>
              School Details
            </v-tab>
            <v-tab @click="showTab(2)">
              <v-icon small left>extension</v-icon>
              Modules
            </v-tab>
            <v-tab @click="showTab(3)">
              <v-icon small left>dns</v-icon>
              Instance
            </v-tab>
          </v-tabs>

          <v-widget :title="activeWidgetTitle" v-if="activeTab == 0">
            <div slot="widget-content">
              <register :company="company">
                <!-- <template v-slot:imageholder>
                  <image-holder :company="company" />
                </template> -->
              </register>
            </div>
          </v-widget>

          <v-widget :title="activeWidgetTitle" v-if="activeTab == 2">
            <div slot="widget-content">
              <modules-to-company :company="company" />
            </div>
          </v-widget>

          <v-widget :title="activeWidgetTitle" v-if="activeTab == 3">
            <div slot="widget-content">
              <manage :company="company">
              </manage>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import VWidget from "@/components/VWidget";
import Register from "@/components/companies/Register";
import Manage from "@/components/companies/Manage";
import ModulesToCompany from "../modules/AssignModuleBulk.vue";
import APICompany from "@/mixins/APICompany";
export default {
  components: {
    VWidget,
    Register,
    Manage,
    Breadcrumbs,
    ModulesToCompany
  },
  mixins: [APICompany],
  data() {
    return {
      isVisible: 0,
      company: {},
      activeTab: 0
    };
  },
  computed: {
    activeWidgetTitle() {
      if (this.activeTab === 2) return "Assigned Modules";
      if (this.activeTab === 3) return "Instance Management";
      return this.company._id ? "School Details" : "Register School";
    },
    queriedUrlId() {
      let url = window.location.href.split("create/");
      return url[1];
    }
  },
  created() {
    this.restoreFrom();
  },
  watch: {},
  methods: {
    showTab: function (index) {
      this.activeTab = index;
    },
    listChanged: function (index) {
      this.isVisible = index;
    },
    loadCompnayPolicies: async function () {
      if (!this.company || !this.company.company_id) return;
      try {
        this.policies = await this.getCompanyPolicies(
          this.company.company_id,
          this.company.url,
          this.company.port
        );
      } catch (error) {
        this.policies = [];
      }
    },
    restoreFrom: async function () {
      if (this.$route.params.object !== undefined) {
        this.company = this.$route.params.object;
      } else if (
        this.$route.params.object === undefined &&
        this.queriedUrlId !== "0"
      ) {
        try {
          let company = await this.getCompanyById(this.queriedUrlId);
          let self = this;
          if (company.length > 0) {
            company = company.filter(obj => {
              return obj._id === self.queriedUrlId;
            });
            this.company = company.length > 0 ? company[0] : Object;
          }
        } catch (error) {
          this.$router.push({ name: "Company" });
        }
      }
    }
  }
};
</script>

<style scoped lang="css">
.company-manage-page {
  background: #f4f7fb;
  min-height: calc(100vh - 64px);
}

.company-manage-container {
  max-width: 1280px;
}

.page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin: 4px 0 16px;
}

.page-heading__eyebrow {
  color: #1565C0;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1.3;
  text-transform: uppercase;
}

.page-heading__title {
  color: #0f172a;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  margin: 4px 0;
}

.page-heading__sub {
  color: #64748b;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.45;
}

.page-heading__status {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 700 !important;
}

.company-tabs {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

.company-tabs >>> .v-tabs__item {
  color: #64748b !important;
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.company-tabs >>> .v-tabs__item--active {
  color: #1565C0 !important;
}

@media (max-width: 600px) {
  .page-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .page-heading__title {
    font-size: 22px;
  }
}
</style>
